import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute } from '@angular/router';
import { TilesModule, ButtonModule, StructuredListModule, IconModule } from 'carbon-components-angular';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { take, forkJoin } from 'rxjs';
import { MatDialogComponent } from 'src/app/mat-dialog/mat-dialog.component';
import { AppService } from 'src/app/services/app.service';
import { EndApproval, GetDetailsResponse, FileLinkWithThumbnail, Client, Approvalstatus, ApprovalStatusLowerCase, StyleSettingsDealerImage, } from 'src/app/services/client.service';
import { TickSnackbarComponent } from 'src/app/tick-snackbar/tick-snackbar.component';

@Component({
  selector: 'app-service-quote-auth',
  standalone: true,
  imports: [
    MatExpansionModule,
    MatIconModule,
    MatDialogModule,
    MatCardModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    CommonModule,
    TilesModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatButtonModule,
    MatSnackBarModule,
    MatMenuModule],
  templateUrl: './service-quote-auth.component.html',
  styleUrl: './service-quote-auth.component.scss'
})
export class ServiceQuoteAuthComponent {

  noPendingRequest: string = $localize`No pending requests`;
  pendingDescription: string = $localize`There are no pending requests for your vehicle.`;
  noAuthorizedRequest: string = $localize`No authorized requests`;
  authorizedDescription: string = $localize`Go to pending requests to approve jobs for your vehicle.`;
  noDeclinedRequest: string = $localize`No declined requests`;
  declinedDescription: string = $localize`Go to pending requests to decline jobs for your vehicle.`;
  pendingRequestsLabel = $localize`:@@pendingRequests:Pending Requests`;
  partsLabel = $localize`:@@parts:Parts`;
  labourLabel = $localize`:@@labour:Labours`;
  glAccount = $localize`:@@glAccount:G/L Account`;
  ExServices = $localize`:@@Ex.Services:External Service`;
  authorizationSent: string = $localize`Authorization sent`;
  authorizedLabel = $localize`:@@authorized:Authorized`;
  declinedLabel = $localize`:@@declined:Declined`;

  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
 
  @Input() apiResponse: any;
  @Output() updateChecklistData = new EventEmitter<void>();
  response: any = null;
  quoteServiceJobs: any = [];
  details: any;
  selectedTab: string = 'pending';
  selectedCategory: string = 'All';
  selectedTabIndex: number = 0;
  allServiceJobs: any[] = [];
  token: string = '';
  serviceJobs: any = [];
  bodyData: EndApproval[] = [];
  locationId: string | undefined;
  companyId: string | undefined;
  quoteId: string | undefined;
  authToken: string = '';
  jobsData: GetDetailsResponse | undefined;
  mediaItems: FileLinkWithThumbnail[] | undefined;
  private swipeCooldown = false;
  isDeclineDisabled = false;
  isRequestCallbackDisabled = false;
  isAuthorizeDisabled = false;
  showDeclineButton = true;
  showAuthorizeButton = true;
  isAuthorized = false;
  totalPendingPrice: number | undefined;
  totalPendingJobsCount: number = 0;
  showFooter = false;
  private lastScrollTop = 0;
  Approvalstatus = Approvalstatus;
  ApprovalstatusLowerCase = ApprovalStatusLowerCase;
  isLargeScreen: boolean = window.innerWidth > 900;
  dealerImageDisplay: boolean = false;
  currentWindowWidth: number = window.innerWidth;
  dealerImageDetails: StyleSettingsDealerImage | undefined;

  @HostListener('swipeleft', ['$event'])
  onSwipeLeft(event: any) {
    if (this.selectedTabIndex < 2 && !this.swipeCooldown) {
      this.swipeCooldown = true;
      this.selectTab(this.selectedTabIndex + 1);
      setTimeout(() => (this.swipeCooldown = false), 300);
    }
  }

  @HostListener('swiperight', ['$event'])
  onSwipeRight(event: any) {
    if (this.selectedTabIndex > 0 && !this.swipeCooldown) {
      this.swipeCooldown = true;
      this.selectTab(this.selectedTabIndex - 1);
      setTimeout(() => (this.swipeCooldown = false), 300);
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (window.innerWidth > 900) {
      if (scrollTop > this.lastScrollTop) {
        this.showFooter = true;
      }
      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.currentWindowWidth = (event.target as Window).innerWidth;
    this.hideDealerImage(); 
  }
  

  private hideDealerImage(): void {
    if (this.dealerImageDetails) {
      this.dealerImageDisplay = !this.dealerImageDetails.url && this.currentWindowWidth > 900;
    } else {
      this.dealerImageDisplay = false;
    }
  }
  constructor(public appService: AppService, private readonly route: ActivatedRoute, private readonly client: Client, public dialog: MatDialog, private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const tabMap = ['pending', 'authorized', 'declined'];
      const filterIndex = tabMap.indexOf(params['filter']);
      if (filterIndex >= 0) {
        this.selectedTab = tabMap[filterIndex];
        this.selectedTabIndex = filterIndex;
        setTimeout(() => this.centerActiveTab());
      } else {
        this.selectedTab = 'pending';
      }
      this.token = (params['token']);
    });
    this.loadChecklistData();
    if (window.innerWidth <= 900) {
      this.showFooter = true;
    }
  }

  checkScreenSize() {
    this.isLargeScreen = window.innerWidth > 900;
  }
  
  get pendingTabLabel(): string {
    return `${this.pendingRequestsLabel} (${this.getPendingRequestsCount()})`;
  }

  get authorizedTabLabel(): string {
    return `${this.authorizedLabel} (${this.allServiceJobs.filter((job: any) => job.approvalStatus === Approvalstatus.Accept).length})`;
  }

  get declinedTabLabel(): string {
    return `${this.declinedLabel} (${this.allServiceJobs.filter((job: any) => job.approvalStatus === Approvalstatus.Reject).length})`;
  }

  private centerActiveTab(): void {
    this.tabGroup?._tabHeader?._scrollToLabel(this.selectedTabIndex);
  }

  loadChecklistData() {
    this.appService.quoteResponseData$.pipe(take(1)).subscribe((data) => {
      if (data) {
        this.apiResponse = data;
        this.details = this.apiResponse.quoteDetails;
        this.companyId = this.apiResponse?.companyId;
        this.quoteId = this.details?.id;
        this.locationId = this.details?.locationId;
        this.authToken = this.apiResponse?.token;
        this.processChecklistData();
      } else {
        forkJoin({
          quoteDetails: this.appService.geServiceQuoteDetails(this.token).pipe(take(1)),
          styleSettings: this.appService.getStyleSettings(this.token).pipe(take(1)),
        }).subscribe({
          next: ({ quoteDetails, styleSettings }) => {
            this.apiResponse = quoteDetails;
            this.details = this.apiResponse.quoteDetails;
            this.companyId = this.apiResponse?.companyId;
            this.quoteId = this.details?.id;
            this.locationId = this.details?.locationId;
            this.authToken = this.apiResponse?.token;
            this.dealerImageDetails = styleSettings?.dealerImage;
            this.hideDealerImage();
            this.processChecklistData();
          },
          error: (error) => {
            this.appService.handleErrorMessage(error);
          }
        });
      }
    });
  }

  private processChecklistData() {
    if (this.apiResponse) {
      this.details = this.apiResponse?.quoteDetails;
      this.fetchQuoteServiceJobs();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['apiResponse']?.currentValue) {
      this.apiResponse = changes['apiResponse'].currentValue;
      this.companyId = this.apiResponse?.companyId;
      this.details = this.apiResponse?.quoteDetails;
      this.locationId = this.details?.locationId;
      this.quoteId = this.details?.id;
      this.authToken = this.apiResponse?.token;
      this.processChecklistData();
    }
  }

  fetchQuoteServiceJobs() {
    if (!this.details?.serviceJobs) return;
    this.allServiceJobs = [...this.details.serviceJobs];

    this.quoteServiceJobs = [...this.allServiceJobs];
    this.applyFilter();
  }

  applyFilter() {
    switch (this.selectedTab) {
      case 'authorized':
        this.quoteServiceJobs = this.allServiceJobs.filter(
          (job: any) => job.approvalStatus === Approvalstatus.Accept
        );
        this.totalPendingJobsCounts();
        this.isDeclineDisabled = true;
        this.isAuthorizeDisabled = true;
        break;
      case 'declined':
        this.quoteServiceJobs = this.allServiceJobs.filter(
          (job: any) => job.approvalStatus === Approvalstatus.Reject
        );
        this.totalPendingJobsCounts();
        this.isDeclineDisabled = true;
        this.isAuthorizeDisabled = true;
        break;
      default: 
      this.quoteServiceJobs = this.allServiceJobs.filter(
        (job: any) => {
          const status = job.approvalStatus?.trim().toLowerCase() || '';
          return status === '' || status === ApprovalStatusLowerCase.NotProvided;
        }
      );
      this.totalPendingJobsAndPendingPrice();
      this.isDeclineDisabled = false;
      this.isAuthorizeDisabled = false;
    }
  }

  totalPendingJobsAndPendingPrice(){
    this.totalPendingJobsCount = this.quoteServiceJobs.length;

    const pendingPrices = this.quoteServiceJobs.flatMap((job: any) =>
      job.priceSummary?.map((priceSummary: any) =>
        priceSummary?.price?.grossPrice || 0
      ) || []
    );

    this.totalPendingPrice = this.calculateGrossTotal(pendingPrices);
  }

  totalPendingJobsCounts(){
    const pendingJobs = this.allServiceJobs.filter(
      (job: any) => {
        const status = job.approvalStatus?.trim().toLowerCase() || '';
        return status === '' || status === ApprovalStatusLowerCase.NotProvided;
      }
    );
    this.totalPendingJobsCount = pendingJobs.length;
  }


  priceTypeLabel(type: string | undefined): string {
    switch (type) {
      case 'Items':
        return this.partsLabel;
      case 'Labours':
        return this.labourLabel;
      case 'G/L Accounts':
        return this.glAccount;
      case 'Ex.Services':
        return this.ExServices;  
      default:
        return type || '';
    }
  }

  calculateGrossTotal(priceSummary: number[]): number {
    const total = priceSummary.reduce((sum, price) => sum + price, 0);
    const roundedTotal = parseFloat(total.toFixed(2));
    return roundedTotal;
  }

  selectTab(index: number) {
    const tabMap = ['pending', 'authorized', 'declined'];
    this.selectedTab = tabMap[index];
    this.selectedTabIndex = index;
    this.applyFilter();
    setTimeout(() => this.centerActiveTab());
  }

  onTabHeaderArrowClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const arrow = target.closest('.mat-mdc-tab-header-pagination-before, .mat-mdc-tab-header-pagination-after');
    if (!arrow) return;

    const nextIndex = this.selectedTabIndex + (arrow.classList.contains('mat-mdc-tab-header-pagination-after') ? 1 : -1);
    if (nextIndex >= 0 && nextIndex < 3) {
      setTimeout(() => {
        this.tabGroup.selectedIndex = nextIndex;
        this.selectTab(nextIndex);
      });
    }
  }


  onButtonGroupClick(buttonName: string, job: any) {
    let context = "Quote";
    if (buttonName === Approvalstatus.Accept) {
      this.approveOrDeclineCall(buttonName, job)
    }
    else {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          context: context,
          serviceJob: job?.description,
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.approveOrDeclineCall(buttonName, job)
        }
      });
    }

  }

  approveOrDeclineCall(buttonName: string, job: any) {
    this.bodyData = [
      <EndApproval>{
        id: String(job.id),
        description: job.description,
        descriptionLong: job.descritpionLong,
        price: job.price,
        approvalStatus: buttonName,
        billToClientName: job.billToCustomerName
      }
    ];

    const locationId = this.locationId?.replace(/[{ }]/g, '');

    this.client.authorizeSevicequoteconsentdetails(this.authToken, this.companyId, this.quoteId, locationId, this.bodyData)
      .subscribe((response: any) => {
        if (response.status === 200 && buttonName) {
          const updatedJob = this.allServiceJobs.find((x: any) => x.id === job.id);
          if (updatedJob) {
            updatedJob.approvalStatus = buttonName;
          }

          if (buttonName === Approvalstatus.Accept) {
            this.showAuthorizationMessage();
          }

          this.applyFilter();
          this.updateChecklistData.emit();
        }
      });
  }

  isObjectEmpty(obj: any): boolean {
    return Object.keys(obj).length === 0;
  }

  onApproveAllOrDeclineAllClick(buttonName: string) {
    const isDisabled =
      (buttonName === Approvalstatus.Accept && (this.isAuthorizeDisabled || (this.totalPendingJobsCount ?? 0) <= 1)) ||
      (buttonName === Approvalstatus.Reject && (this.isDeclineDisabled || (this.totalPendingJobsCount ?? 0) <= 1));

    if (isDisabled) {
      return;
    }

    const serviceJobs = Array.isArray(this.quoteServiceJobs) ? [...this.quoteServiceJobs] : [];

    const arrayOfMatchedData = serviceJobs.filter(
      (job: any) => job.approvalStatus !== Approvalstatus.Accept && job.approvalStatus !== Approvalstatus.Reject
    );

    const dialogRef = this.dialog.open(MatDialogComponent, {
      data: {
        type: buttonName + 'Disclaimer',
        jobs: (arrayOfMatchedData.length == this.serviceJobs.length) ? 'all' : arrayOfMatchedData.length,
        cost: this.totalPendingPrice
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.approveOrDeclineAllCall(buttonName);
      }
    });
  }

  approveOrDeclineAllCall(buttonName: string) {
    const serviceJobs = Array.isArray(this.quoteServiceJobs) ? [...this.quoteServiceJobs] : [];
    const arrayOfMatchedData = serviceJobs.filter(
      (job: any) => job.approvalStatus !== Approvalstatus.Accept && job.approvalStatus !== Approvalstatus.Reject
    );

    this.bodyData = arrayOfMatchedData.map((job: any) => <EndApproval>{
      id: String(job.id),
      description: job.description,
      descriptionLong: job.descritpionLong,
      price: job.price,
      approvalStatus: buttonName,
      billToClientName: job.billToCustomerName
    });

    const locationId = this.locationId?.replace(/[{ }]/g, '');

    this.client.authorizeSevicequoteconsentdetails(
      this.authToken,
      this.companyId,
      this.quoteId,
      locationId,
      this.bodyData
    ).subscribe({
      next: () => {
        arrayOfMatchedData.forEach((job: any) => {
          job.approvalStatus = buttonName;
        });

        this.updateButtonStates(buttonName);
        this.applyFilter();
        this.updateChecklistData.emit();
      },
      error: (error) => {
        this.appService.handleErrorMessage(error);
      }
    });
  }

  updateButtonStates(buttonName: string) {
    if (buttonName === Approvalstatus.Accept) {
      this.isAuthorizeDisabled = true;
      this.isDeclineDisabled = true;
      this.isRequestCallbackDisabled = true;
    } else if (buttonName === Approvalstatus.Reject) {
      this.isDeclineDisabled = true;
      this.isAuthorizeDisabled = true;
      this.isRequestCallbackDisabled = true;
    } else if (buttonName === Approvalstatus.NotProvided) {
      this.isRequestCallbackDisabled = false;
      this.isAuthorizeDisabled = false;
      this.isDeclineDisabled = false;
    }
  }

  getNoJobsMessage(): { title: string; description: string } {
    switch (this.selectedTab) {
      case 'pending':
        return {
          title: this.noPendingRequest,
          description: this.pendingDescription
        };
      case 'authorized':
        return {
          title: this.noAuthorizedRequest,
          description: this.authorizedDescription
        };
      case 'declined':
        return {
          title: this.noDeclinedRequest,
          description: this.declinedDescription
        };
      default:
        return {
          title: 'No jobs available',
          description: `There are no job recorded for your vehicle at the moment.`
        };
    }
  }

  getPendingRequestsCount(): number {
    return (this.totalPendingJobsCount);
  }

  getTotalGrossPrice(priceSummary: any[]): number {
    if (!priceSummary || !Array.isArray(priceSummary)) return 0;
    return priceSummary.reduce((total, item) => total + ((item?.price?.grossPrice || item?.grossPrice) || 0), 0).toFixed(2);
  }

  getTotalDiscount(priceSummary: any[]): number {
    if (!priceSummary || !Array.isArray(priceSummary)) return 0;
    return Number(priceSummary.reduce((total, item) => total + ((item?.price?.discount?.amount || item?.discount?.amount) || 0), 0).toFixed(2));
  }

  getTotalTaxes(priceSummary: any[]): string {
    if (!priceSummary || !Array.isArray(priceSummary)) return '0.00';
    const totalTax = priceSummary.reduce((total, item) => {
      const taxes = item?.price?.taxes || [];
      const taxSum = taxes.reduce((taxTotal: number, tax: any) => taxTotal + (tax?.value || 0), 0);
      return total + taxSum;
    }, 0);
    return totalTax.toFixed(2);
  }

  showAuthorizationMessage(): void {
    this.snackBar.openFromComponent(TickSnackbarComponent, {
      data: this.authorizationSent,
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['custom-snackbar']
    });
  }

  getCurrency(priceSummary: any[]): string {
    if (!priceSummary || !Array.isArray(priceSummary) || priceSummary.length === 0) {
      return 'USD';
    }
    
    const priceWithCurrency = priceSummary.find(item => item?.currency || item?.price?.currency);
    return priceWithCurrency?.currency || priceWithCurrency?.price?.currency || 'USD';
  }
}
